import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';

import {
  getOrder,
  pushPlacementsAndUpdateOrder,
  cloneOrderWithNotifications,
  pushOrderWithNotifications,
  deleteOrder,
  getChangeLog,
} from "../actions/orderActions";
import { getConstants } from "../actions/constantActions";
import { getStrategies, getSalesProducts } from "../actions/strategyActions";
import { getDeviceTypes } from "../actions/deviceTypesActions";
import { getCreativeProducts } from "../actions/creativeProductActions";
import { getPresets, getTPTs } from "../actions/presetActions";
import { setPlacement, saveMultipleAndNotify } from '../actions/placementActions';
import { pushPackagesAndNotify, saveMultiplePackagesAndNotify } from '../actions/packageActions';
import { getGeotargetsByType } from "../actions/geotargetsActions";
import { exportPlacements, importPlacements } from './placement/importExport';
import { importFile } from '../utils/file';
import { countLineItems } from '../utils/countLineItems';
import { isReadOnly } from '../utils/readOnly';
import IoPage from '../components/IoPage';
import ErrorPage from '../errors/ErrorPage';
import Spinner from '../components/Spinner';
import AlertDialog from '../components/utils/AlertDialog';
import WaitDialog from '../components/utils/WaitDialog';
import ChangeLog from '../components/ChangeLog';
import AttachmentsView from './AttachmentsView';
import PushSettings from '../components/PushSettings';

const IO_STATUS_CAN_PUSH = 4;


class Io extends Component {

  state = {
    importErrors: [],
    changeLogOpen: false,
    importExportOpen: false,
    pushSettingsOpen: false,
    cloneDialogOpen: false,
    itemRemainder: 0,
    itemLimit: 0,
    pushSettings: [],
    selectedPlacements: [],
    selectedPackages: [],
    alertDialog: {
      open: false,
      title: '',
      message: ''
    },
    waitDialog: {
      open: false,
      title: '',
      message: ''
    }
  };

  async componentDidMount() {
    document.title = 'GALILEO - Order';
    const {
      dispatch,
      match,
      order,
      constants,
      strategies,
      deviceTypes,
      salesProducts,
      creativeProducts,
      presets,
      tpts,
      geos
    } = this.props;
    const {id} = match.params;
    if (isEmpty(constants)) {
      dispatch(getConstants());
    }
    if (isEmpty(strategies)) {
      dispatch(getStrategies());
    }
    if (isEmpty(salesProducts)) {
      dispatch(getSalesProducts());
    }
    if (isEmpty(deviceTypes)) {
      dispatch(getDeviceTypes());
    }
    if (isEmpty(creativeProducts)) {
      dispatch(getCreativeProducts());
    }
    if (isEmpty(presets)) {
      dispatch(getPresets());
    }
    if (isEmpty(tpts)) {
      dispatch(getTPTs());
    }
    if (isEmpty(geos)) {
      dispatch(getGeotargetsByType());
    }
    if (isEmpty(order) || order.id.toString() !== id) {
      toast.dismiss();
      dispatch(getOrder(id)).then(() => {
        document.title = `Order ${this.props.order ? this.props.order.agencyOrderName : ''} - GALILEO`;
      });
    } else {
      document.title = `Order ${order.agencyOrderName} - GALILEO`;
    }
    this.setLineItemCount();
    await dispatch(setPlacement({}));

    // check if the attachments view should be open
    const locationHash = (window.document.location.hash || "");
    if (locationHash.startsWith("#attachment")) {
      this.toggleAttachments(); // Yes, open attachments view
      const match = locationHash.match(/attachment-(\d+)-(.+)/);
      if (match) {
        // URL hash indicates a direct link to a attached file. We will ask if they want to download it
        const downloadAttachmentId = match[1];
        const downloadAttachmentName = unescape(match[2]);
        this.setState(state => ({downloadAttachmentId, downloadAttachmentName}))
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.location.pathname.includes('refresh') || nextProps.location.pathname.includes('refresh')) {
      if (nextProps.location.pathname !== this.props.location.pathname) {
        window.location.reload(true);
      } else {
        if (this.props.location.pathname.slice(-8) === '/refresh') {
          this.props.history.push(this.props.location.pathname.slice(0, -8));
        }
      }
    }
  }

  setLineItemCount = () => {
    const {itemRemainder, itemLimit} = countLineItems(this.props.order);
    this.setState({itemRemainder, itemLimit});
  };

  getChangeLog = () => {
    const {dispatch, match} = this.props;
    const {id} = match.params;
    dispatch(getChangeLog(id));
  };

  onClone = (newIOAgencyName, newIOAgencyId, newAdvertiserId) => {
    const {dispatch, order, history} = this.props;
    dispatch(cloneOrderWithNotifications(order, {
      name: newIOAgencyName,
      ID: newIOAgencyId,
      advertiserId: newAdvertiserId
    }, history));
  };

  delete = () => {
    const dialog = {};
    dialog.open = true;
    dialog.title = 'Delete Entire ORDER with all placements';
    dialog.onCancel = this.closeDialog;
    dialog.message = `Are you sure you want to delete this entire order?`;
    dialog.onOk = this.confirmDelete;
    dialog.okTitle = 'Delete';
    dialog.okColor = "secondary";
    dialog.cancelTitle = 'Cancel';
    this.setState({alertDialog: dialog});
  };

  confirmDelete = () => {
    const {dispatch, history, order} = this.props;
    this.closeDialog();
    dispatch(deleteOrder(order.id)).then(() => {
      history.push(`/advertiser/${order.AdvertiserId}`);
    })
  };

  closeDialog = () => {
    this.setState({
      alertDialog: {
        open: false,
        title: '',
        message: '',
        onCancel: null,
        onOk: null,
        cancelTitle: '',
        okTitle: '',
        okColor: '',
      }
    })
  };

  setPushData = (selected, type) => {
    if (type === 'packages') {
      this.setState({ selectedPackages: selected });
    } else {
      this.setState({ selectedPlacements: selected });
    }
  }

  pushPlacementsFromOrder = (pushSettings) => {
    // console.log('IO push placements from order');
    const { dispatch, order, history } = this.props;
    const { selectedPlacements } = this.state;
    const ids = selectedPlacements.map(pl => (typeof pl === "object") ? pl.id : pl);
    const pushRules = this.getPushRules(pushSettings);
    dispatch(pushPlacementsAndUpdateOrder(order.id, ids, pushRules, history));
  }

  pushPlacementsFromPackage = (pushSettings) => {
    // console.log('IO push placements from package');
    const { dispatch, order, history } = this.props;
    const { selectedPlacements } = this.state;
    const ids = selectedPlacements.map(pl => (typeof pl === "object") ? pl.id : pl);
    const pushRules = this.getPushRules(pushSettings);
    dispatch(pushPlacementsAndUpdateOrder(order.id, ids, pushRules, history));
  }

  pushPackages = (pushSettings) => {
    // console.log('IO pushPackages', this.state.selectedPackages);
    const { dispatch, order } = this.props;
    const { selectedPackages } = this.state;
    const ids = selectedPackages.map(pl => (typeof pl === "object") ? pl.id : pl);
    const pushRules = this.getPushRules(pushSettings);
    dispatch(pushPackagesAndNotify(order.id, ids, pushRules)).then(() => {
      setInterval(() => {
        window.location.reload(true);
      }, 3 * 1000);
    })
  }

  pushOrder = (pushSettings) => {
    const { dispatch, order } = this.props;
    const pushRules = this.getPushRules(pushSettings);
    dispatch(pushOrderWithNotifications(order.id, pushRules));
  };

  getPushRules = (pushSettings) => {
    const pushRules = [];
    if (pushSettings) {
      pushRules.push(pushSettings);
    }
    if (localStorage.getItem('soapLog')) {
      pushRules.push('soapLog')
    }
    if (localStorage.getItem('gamDirect')) {
      pushRules.push('gamDirect')
    }
    if (localStorage.getItem('forceStart')) {
      pushRules.push('forceStart')
    }
    return pushRules;
  };

  exportCsv = () => {
    const { order } = this.props;
    exportPlacements(order, order.Placements);
  };

  newPackage = () => {
    const { order, history } = this.props;
    history.push(`/ios/${order.id}/package/create`);
  }

  awaitImport = () => {
    const dialog = {};
    dialog.open = true;
    dialog.title = 'Import processing';
    dialog.message = `Import validated. Please wait several minutes while we process your file. Do not refresh until it is complete.`;
    this.setState({ waitDialog: dialog });
  };

  importCsv = file => {
    const { order, constants, strategies, deviceTypes, salesProducts, creativeProducts, presets, geos } = this.props;
    importFile(file, importPlacements(order, this.validatedImport, this.toggleImportExport, constants, strategies, deviceTypes, salesProducts, creativeProducts, presets, geos,false));
  };

  validatedImport = results => {
    const { dispatch } = this.props;
    if (results.errors.length > 0) {
      this.setState({ importErrors: results.errors });
      return;
    }
    this.setState({ importErrors: [] });
    if (results.packages && results.packages.length > 0) {
      this.awaitImport();
      dispatch(saveMultiplePackagesAndNotify(results)).then(() => {
        window.location.reload(true);
      });
    } else if (results.placements && results.placements.length > 0) {
      this.awaitImport();
      dispatch(saveMultipleAndNotify(results.placements)).then(() => {
        setInterval(() => {
          window.location.reload(true);
        }, 5 * 1000);
      });
    }
  };

  downloadCsvTemplate = () => {
    const { order } = this.props;
    exportPlacements(order, []);
  };

  toggleChangeLog = () => {
    this.setState(prevState => ({ changeLogOpen: !prevState.changeLogOpen }));
  };

  togglePushSettings = () => {
    this.setState(prevState => ({ pushSettingsOpen: !prevState.pushSettingsOpen }));
  };

  clearDownloadAttachmentId = () => {
    this.setState({downloadAttachmentId: null, downloadAttachmentName: null})
  }

  toggleAttachments = () => {
    this.setState(state => {
      const attachmentsOpen = !state.attachmentsOpen;
      if (attachmentsOpen) {
        window.document.location.hash = "attachments"
      } else if ((window.document.location.hash || "").startsWith("#attachment")) {
        window.document.location.hash = "";
      }
      return { attachmentsOpen: attachmentsOpen};
    })
  };

  toggleImportExport = () => {
    this.setState(prevState => ({ importExportOpen: !prevState.importExportOpen }));
  };

  setCloneDialog = () => {
    console.log('io.js set CloneDialogOpen true');
    this.setState({ cloneDialogOpen: true });
  };

  setCloneDialogFalse = () => {
    console.log('io.js set CloneDialogOpen false');
    this.setState({ cloneDialogOpen: false });
  };

  render() {
    const {
      changeLog,
      order,
      constants,
      geos,
      strategies,
      deviceTypes,
      salesProducts,
      creativeProducts,
      presets,
      tpts,
      isFetching,
      error,
      isFetchingLog,
      isFetchingAttachments,
      isUploadingAttachment,
      attachment,
      attachments,
      dispatch,
      userInfo,
      onPush,
      setPushData,
      ...other
    } = this.props;

    const { alertDialog, waitDialog, itemRemainder } = this.state;
    let cannotPushReason = null;
    const canPush = order => {
      const { itemRemainder, itemLimit } = countLineItems(order);
      if (!order) {
        cannotPushReason = 'Order cannot be pushed because it is from the old 2909 network';
        return false;
      }
      if (order.orderType === 'Programmatic' || order.IoStatusId >= IO_STATUS_CAN_PUSH) {
        if (itemRemainder > -1) {
          cannotPushReason = null;
          return true;
        } else {
          cannotPushReason = `Ad Manager has a ${itemLimit} line item limit which this order exceeds`;
          return false;
        }
      }
      cannotPushReason = 'Order status must be written agreement or signed IO to push to Ad Manager';
      return false;
    };

    const hasLoadedOrder = !!(order && order.id);

    return(
      <div>
        {isFetching && <Spinner />}
        {!isFetching && error && !hasLoadedOrder && (
          <ErrorPage error={error} entity="order" />
        )}
        {!isFetching && hasLoadedOrder && (
        <div>
          <AlertDialog {...alertDialog} />
          <WaitDialog {...waitDialog} />
            {this.state.changeLogOpen && (
            <ChangeLog
              open={this.state.changeLogOpen}
              order={order}
              onLoad={this.getChangeLog}
              onClose={this.toggleChangeLog}
              isFetchingLog={isFetchingLog}
              changeLog={changeLog}
            />
            )}
          {this.state.pushSettingsOpen && (
            <PushSettings
              open={this.state.pushSettingsOpen}
              order={order}
              pushType='order'
              onPushOrder={canPush(order) ? this.pushOrder : null}
              pushPlacementsFromOrder={this.pushPlacementsFromOrder}
              onPushPackages={this.pushPackages}
              pushPlacementsFromPackage={this.pushPlacementsFromPackage}
              onClose={this.togglePushSettings}
              whitelist={constants.whitelistedDevs}
              caller={'io.js'}
            />
          )}
            {this.state.attachmentsOpen && (
            <AttachmentsView
              ioid={order.id}
              open={this.state.attachmentsOpen}
              downloadAttachmentId={this.state.downloadAttachmentId}
              downloadAttachmentName={this.state.downloadAttachmentName}
              order={order}
              isFetchingAttachments={isFetchingAttachments}
              isUploadingAttachment={isUploadingAttachment}
              onClose={this.toggleAttachments}
              onClearDoanloadAttachmentId={this.clearDownloadAttachmentId}
              attachment={attachment}
              attachments={attachments}
              dispatch={dispatch}
              isReadOnly={isReadOnly(userInfo)}
            />
            )}

          <IoPage
            order={order}
            constants={constants}
            geos={geos}
            strategies={strategies}
            deviceTypes={deviceTypes}
            salesProducts={salesProducts}
            creativeProducts={creativeProducts}
            presets={presets}
            dispatch={dispatch}
            onClone={this.onClone}
            cloneDialogOpen={this.state.cloneDialogOpen}
            setCloneDialog={this.setCloneDialog}
            setCloneDialogFalse={this.setCloneDialogFalse}
            onExport={this.exportCsv.bind(this)} // eslint-disable-line
            onImport={this.importCsv}
            onNewPackage={this.newPackage}
            toggleChangeLog={this.toggleChangeLog}
            togglePushSettings={this.togglePushSettings}
            toggleAttachments={this.toggleAttachments}
            importExportOpen={this.state.importExportOpen}
            toggleImportExport={this.toggleImportExport}
            onDelete={(order.IoStatusId < IO_STATUS_CAN_PUSH) ? this.delete : null}
            importErrors={this.state.importErrors}
            cannotPushReason={cannotPushReason}
            onTemplateDownload={this.downloadCsvTemplate}
            itemRemainder={itemRemainder}
            isReadOnly={isReadOnly(userInfo)}
            amPushRules={this.getPushRules()}
            onPushOrder={canPush(order) ? this.pushOrder : null}
            pushPlacementsFromOrder={this.pushPlacementsFromOrder}
            onPushPackages={this.pushPackages}
            setIOSelected={this.setIOSelected}
            setPushData={this.setPushData}
            error={error}
            {...other}
          />
        </div>
        )}
      </div>
    )
  }

}

const mapStateToProps = state => {
  const {
    orderRequest,
    placementRequest,
    advertiserRequest,
    acceptRequest,
    constantRequest,
    ccpRequest,
    tptRequest,
    geoRequest,
    strategyRequest,
    deviceTypesRequest,
    salesProductsRequest,
    creativeProductsRequest,
    user
  } = state;

  return {
    constants: constantRequest.constants,
    strategies: strategyRequest.strategies,
    deviceTypes: deviceTypesRequest.deviceTypes,
    salesProducts: salesProductsRequest.salesProducts,
    creativeProducts: creativeProductsRequest.creativeproducts,
    presets: ccpRequest.ccp,
    tpts: tptRequest.tpt,
    geos:geoRequest.geos,
    order: orderRequest.order,
    error: orderRequest.error,
    advertiser: advertiserRequest.advertiser,
    accept: acceptRequest.accept,
    isFetching: orderRequest.isFetching ||
      ccpRequest.isFetching ||
      salesProductsRequest.isFetching ||
      strategyRequest.isFetching ||
      deviceTypesRequest.isFetching ||
      creativeProductsRequest.isFetching ||
      geoRequest.isFetching ||
      tptRequest.isFetching,
    pushRequest: (placementRequest || {}).pushRequest,
    pushError: ((placementRequest || {})).pushError,
    pushResult: ((placementRequest || {})).pushResult,
    changeLog: orderRequest.changeLog,
    isFetchingLog: orderRequest.isFetchingLog,
    isFetchingAttachments: orderRequest.isFetchingAttachments,
    isUploadingAttachment: orderRequest.isUploadingAttachment,
    attachment: orderRequest.attachment,
    attachments: orderRequest.attachments,
    userInfo: {
      name: user.displayName,
      email: user.email,
      role: user.roleName
    },
  }
};

export default connect(mapStateToProps)(Io);
